import { CSSVariablesResolver } from "@mantine/core";

import { BORDER_COLOR } from "./mantine.constants";
import { IDatePickerFieldProps } from "./mantine.models";

/**
 * A `DatePickerInput` is a button, and HTML gives a button no accessible name
 * from its `<label>` — a screen reader would read out the date and never the
 * field it belongs to. Pointing the button at both its label and itself brings
 * back "Date from, 13.08.2026"; Mantine derives the label's id from this one.
 */
export const toDatePickerFieldProps = (id: string): IDatePickerFieldProps => ({
  id,
  "aria-labelledby": `${id}-label ${id}`,
});

/**
 * Mantine's semantic variables pointed at `libs/theme` tokens, so a Mantine
 * input and a Tailwind-styled card sit on the same surface, ink and hairline.
 * Only the light scheme is filled in — the dashboard has no dark mode.
 */
export const resolveMantineCssVariables: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    "--mantine-color-text": "var(--color-ink-900)",
    "--mantine-color-body": "var(--color-surface)",
    "--mantine-color-dimmed": "var(--color-ink-500)",
    "--mantine-color-placeholder": "var(--color-ink-500)",
    "--mantine-color-default": "var(--color-surface)",
    "--mantine-color-default-hover": "var(--color-surface-muted)",
    "--mantine-color-default-color": "var(--color-ink-900)",
    "--mantine-color-default-border": BORDER_COLOR,
    "--mantine-color-disabled": "var(--color-surface-muted)",
    "--mantine-color-disabled-color": "var(--color-ink-500)",
  },
  dark: {},
});
